import { useCallback, useState } from "react";
import { Pod, PodProvider } from "../../../api/pods.types";
import RemoveProviderDialog from "../dialogs/RemoveProviderDialog";

const useRemoveProviderDialog = (pod: Pod | undefined, handleConfirm: (providerId: string, name: string) => void): [JSX.Element, Function, Function, Function] => {
  const [visible, setVisible] = useState(false);
  const [provider, setProvider] = useState<PodProvider>();
  const [loading, setLoading] = useState(false);

  const fullName = provider ? `${provider.firstName} ${provider.lastName}, ${provider.suffix}` : 'this provider';

  const showDialog = useCallback((id: string): void => {
    const provider = pod?.providers.find(provider => provider.id === id);

    setLoading(false);
    setProvider(provider);
    setVisible(true);
  }, [pod]);

  const hideDialog = () => {
    setVisible(false);
  };

  const setIsLoading = (loading: boolean) => {
    setLoading(loading);
  };

  const dialogComponent = (
    <RemoveProviderDialog
      show={visible}
      name={fullName}
      loading={loading}
      onConfirm={() => {
        if (pod && provider) {
          handleConfirm(provider?.id, fullName);
        }
      }}
      onCancel={hideDialog}
    />
  );

  return [
    dialogComponent,
    showDialog,
    hideDialog,
    setIsLoading,
  ];
};

export default useRemoveProviderDialog;